/**
 * 引入POST、BASE_URL
 * @param params
 * @returns {*}
 */
// export const urls="http://47.104.173.17:9002/evaluate"
// export const urls = "https://api.51xiaoping.com/evaluate"

// export const urls = 'http://beta.sso.51xiaoping.com/#/' //统一跳转前置路径

// export const urls = 'http://sso.51xiaoping.com/#/' //统一跳转前置路径

// export const urls="http://test.api.51xiaoping.com/evaluate"
//export const urls="http://192.168.1.180:9002/evaluate"
//export const urls="http://192.168.1.113:9002/evaluate"
// import urls from './home'
import { POST, BASE_URL, down } from '../api/index'
import { urls } from "./home";


// 获取全部科室列表
export function getdepartmentlist(params) {
	return POST(urls + '/school/getdepartmentlist', params, 'get', '')
}

// 获取教师列表
export function teacherLists(params) {
	return POST(urls + '/teacher/list', params, 'get', '')
}

// 保存科室
export function schoolDepartment(params) {
	return POST(urls + '/school/department', params, 'post', '')
}

// 删除科室
export function schoolDeleteDepartment(params) {
	return POST(urls + '/school/department/' + params, '', 'delete', '')
}


// WEBPACK FOOTER //
// ./src/api/departmen.js